/* ============================================================================
   ClientSidenav — menu lateral do site do cliente.
   Reutiliza o mesmo Sidenav colapsável do painel admin (UI compartilhada),
   apenas com o conjunto de navegação e o logout do aluno.
   ============================================================================ */
import { useNavigate } from 'react-router-dom';
import Sidenav from '../admin/components/Sidenav';
import { IconCourses, IconBook, IconPlans, IconChapter, IconProfile } from '../admin/components/icons';
import '../admin/theme.css';
import './ClientSidenav.css';

const CLIENT_NAV = [
  { icon: IconCourses, label: 'Catálogo', path: '/treinamentos/cursos' },
  { icon: IconBook, label: 'Meus Cursos', path: '/treinamentos/meus-cursos' },
  { icon: IconPlans, label: 'Planos', path: '/treinamentos/planos' },
  { icon: IconChapter, label: 'Plano de Estudos', path: '/treinamentos/plano-estudos' },
  { icon: IconProfile, label: 'Perfil', path: '/treinamentos/perfil' },
];

export default function ClientSidenav() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    navigate('/treinamentos');
  };

  return <Sidenav items={CLIENT_NAV} brandSub="Aluno" homePath="/treinamentos/cursos" onLogout={handleLogout} />;
}
